/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelSalespersonLookup.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const AutogenUserSavedSearchEndpoint = "lme/ar/salesperson-lookup";

export class AutogenModelSalespersonLookup<RowType extends ModelRow> extends Endpoint<RowType, RowSalespersonLookupFields> {
    constructor(ctor: RowConstructor) {
        super(AutogenUserSavedSearchEndpoint, ctor);
    }
}

export class AutogenRowSalespersonLookup extends ModelRow<RowSalespersonLookupFields> {
    constructor(values?: Partial<RowSalespersonLookupFields>) {
        super(AutogenUserSavedSearchEndpoint, true, values);
    }
}

export interface RowSalespersonLookupFields {
    address: string;
    city: string;
    company_id: string;
    id: string;
    is_manager: string;
    name: string;
    percentage: number;
    sales_manager_id: string;
    state: string;
    user_id: string;
    zip_code: string;
}

